<template>
  <section>
    <MatchListItem
      v-for="match in matchs"
      :match="match"
      :key="match.id"/>
  </section>
</template>

<script>
import MatchListItem from '@/components/MatchListItem'
import ApiMatchs from '@/api/matchs'
export default {
  components: {
    MatchListItem
  },
  data () {
    return {
      matchs: []
    }
  },
  created: function () {
    ApiMatchs.get.getMatchs().then(response => {
      this.matchs = response.body
    }).catch((error) => {
      throw error
    })
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/MatchList.vue